import { render, staticRenderFns } from "./ProjectCardHome.vue?vue&type=template&id=4ce5d84f&scoped=true&"
import script from "./ProjectCardHome.vue?vue&type=script&lang=ts&"
export * from "./ProjectCardHome.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectCardHome.vue?vue&type=style&index=0&id=4ce5d84f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce5d84f",
  null
  
)

export default component.exports